import React from "react";
import Navbar from "../Navbar/Navbar";
import MobileNavbar from "../MobileNavbar/MobileNavbar";
import styles from "./hero.module.scss";
// import { Link } from "react-router-dom";
// import hero_section_image from '../../../assets/new-banners/square_banner.png'
// import hero_section_image from '../../../assets/new-banners/providing radiology and diagnostic center with PACS.gif'
import mill_v from '../../../assets/new-banners/providing radiology and diagnostic center with PACS.mp4'
import { GrFormNextLink } from "react-icons/gr";




const Hero = ({lang , path}) => {
  const content = {
    en: {
        header: 'Empowering Healthcare with Small Innovations, Big Achievements',
        subHeader: 'At MILLENSYS, we believe that minor innovations pave the way for significant advancements. With advanced solutions like PACS, VNA, RIS, Polyclinic Solution, Teleradiology, and Mobile Apps, we are transforming healthcare delivery in the Saudi market. From seamless imaging management to remote diagnostics and patient-centered care, our technology empowers healthcare providers to achieve more, one step at a time. Together, let’s turn small innovations into remarkable achievements.',
        buttonText: 'Request a Free Demo',
    },
    ar: {
      header: 'تطوير الرعاية الصحية بالابتكارات الصغيرة والإنجازات الكبيرة',
      subHeader: 'في شركة MILLENSYS نؤمن بأن الابتكارات الصغيرة تمهد الطريق للتقدم الكبير. من خلال حلول متقدمة مثل نظم أرشفة الصور (PACS)، نظم أرشفة الصور والمعلومات (VNA)، نظم معلومات الأشعة (RIS)، حلول العيادات المتعددة، التطبب عن بعد، والتطبيقات المحمولة، نقوم بتحويل تقديم الرعاية الصحية في السوق السعودي. بدءًا من إدارة الصور بسلاسة إلى التشخيص عن بُعد ورعاية المريض المركزة، تقنياتنا تمكن مقدمي الرعاية الصحية من تحقيق المزيد خطوة بخطوة. دعونا معًا نحول الابتكارات الصغيرة إلى إنجازات ملحوظة.',
      buttonText: 'اطلب عرض تجريبي مجاني',
    }
  };
  return (
    <section className={styles.hero_mainContainer}>
      <Navbar />
      <MobileNavbar />
      <div className={styles.hero_content_container}>           
          <div className={`${styles.hero_heading} ${lang === 'ar'&&styles.ar_text}`}>
            <h1>{content[lang].header}</h1>
            <p>{content[lang].subHeader}</p>
            <button className={`${styles["glow-on"]} ${lang === 'ar'&&styles.ar_text}`} >
              <a href={path} className={styles["glow-on-link"]} >{content[lang].buttonText}<GrFormNextLink /></a>
            </button>
          </div>
          <div className={styles.hero_media}>
            {/* <img src={hero_section_image} alt="hero_section_image" loading="lazy"/> */}
            <div className={`${styles["container"]} `}>
                    <video  loading="lazy"  src={mill_v} autoPlay loop muted ></video>
                </div>
          </div>
      </div>
    </section>
  );
};

export default Hero;
//controls
